import React, { Component } from 'react';

class AdSenseFeed extends Component {
    componentDidMount() {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }


    render() {
        return (
            <div style={{ margin: '0 auto' }}>
                <span>Ad</span>              
                <ins className='adsbygoogle'
                    style={{ display: 'block' }}
                    data-ad-format="fluid"
                    data-ad-layout-key="-fb+5w+4e-db+86"
                    data-ad-client="ca-pub-1551799716386587"
                    data-ad-slot="1324571682"></ins>
            </div>    
        );
    }
}

export default AdSenseFeed;


// WEBPACK FOOTER //
// ./src/componentes/AdSenseFeed.js